import { useSetMapId } from "@/Pages/Auth/Maps/useMapId";
import { useSetConfirm } from "@/shared/atoms/useConfirm";
import { useSetModal } from "@/shared/atoms/useModal";
import useCommon from "@/shared/hooks/useCommon";
import { guidGenerator } from "@/shared/utils/helpers";
import { TableMap, useSetTableMaps } from "./useMaps";

const useMapsHook = () => {
  const t = useCommon();
  const confirm = useSetConfirm();
  const setModal = useSetModal();
  const setMapId = useSetMapId();
  const setMaps = useSetTableMaps();
  const add = (name: string) => {
    const id = guidGenerator();
    const map: TableMap = {
      name,
      id,
      tables: [],
    };
    setMaps((current) => [...current, map]);
    setMapId(id);
  };

  const destroy = (id: string) => {
    confirm({
      message: t("confirmationMessage"),
      cb: () => {
        setMapId("");
        setMaps((current) => current.filter((m) => m.id !== id));
        setModal("");
      },
    });
  };

  const update = (id: string, name: string) => {
    setMaps((current) =>
      current.map((map) => (map.id === id ? { ...map, name } : map))
    );
  };
  return { add, destroy, update };
};

export default useMapsHook;
